/* Alta en Brevo desde los formularios de newsletter que no son el panel del 10 %.

   El panel del 10 % (cs-popup.js) ya avisaba a Brevo. El formulario del final
   de la portada y el aviso de la página de ofertas solo daban de alta en
   Shopify: quien se suscribía por ahí no entraba en la lista de la web ni
   recibía la bienvenida (5 oct 2026).

   Se hace lo mismo que en el panel. Se deja pasar el envío nativo, que es el
   único que lleva el token del CAPTCHA de Shopify, y de camino se manda el
   correo al backend de Ebora (/newsletter) con sendBeacon: es el único envío
   que el navegador garantiza aunque la página se esté yendo. El backend lo da
   de alta en Brevo y manda la bienvenida.

   Se activa en cualquier formulario que esté dentro de un elemento con
   data-cs-brevo="<origen>" y data-asesor="<URL del backend>". Sin URL no hace
   nada, y el alta de Shopify sigue su curso igualmente. */
(function () {
  function correoValido(valor) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(valor);
  }

  document.addEventListener('submit', function (evento) {
    var formulario = evento.target;
    if (!formulario || !formulario.closest || !navigator.sendBeacon) return;

    var caja = formulario.closest('[data-cs-brevo]');
    if (!caja) return;

    var base = (caja.getAttribute('data-asesor') || '').replace(/\/+$/, '');
    var campo = formulario.querySelector('input[type="email"]');
    if (!base || !campo) return;

    var correo = campo.value.trim();
    if (!correoValido(correo)) return;

    /* Un doble clic no debe mandar dos bienvenidas. */
    if (formulario.getAttribute('data-cs-brevo-enviado') === correo) return;
    formulario.setAttribute('data-cs-brevo-enviado', correo);

    try {
      navigator.sendBeacon(
        base + '/newsletter',
        new Blob([JSON.stringify({ correo: correo, origen: caja.getAttribute('data-cs-brevo') || 'web' })], {
          type: 'application/json',
        })
      );
    } catch (e) {
      /* sin beacon, el alta de Shopify sigue su curso igualmente */
    }
  });
})();
